import { DocumentNode } from 'graphql';

import { mapSavingFormDataToInput, mapSavingToFormData } from '../../SavingsWidget.util';
import { savingFormDefaultValues, savingFormSchema } from '../SavingForm/SavingForm.schema';
import { createEditableWidgetGraphqlBackendHook } from '@/shared/hooks/useEditableWidgetGraphqlBackend/useEditableWidgetGraphqlBackend';
import { I18nNamespace } from '~/common/types';

import { UPDATE_SAVING_MUTATION } from './EditSavingDialog.mutation.gql.ts';
import { GET_SAVING_QUERY } from './EditSavingDialog.query.gql.ts';

const useEditSavingBackendInternal = createEditableWidgetGraphqlBackendHook({
  schema: savingFormSchema,
  query: GET_SAVING_QUERY as DocumentNode,
  mutation: UPDATE_SAVING_MUTATION as DocumentNode,
});

export const useEditSavingBackend = (id: string | null) => {
  const backend = useEditSavingBackendInternal({
    i18n: {
      ns: I18nNamespace.common,
      keyPrefix: 'Savings.editDialog',
    },
    variables: {
      id: id!,
    },
    skip: !id,
    toFormData: (data) => {
      if (!data.saving) {
        return savingFormDefaultValues;
      }

      return mapSavingToFormData(data.saving);
    },
    toMutationData: (formData, data) => ({
      id: id!,
      input: mapSavingFormDataToInput(formData, data?.saving?.sourceReferences ?? []),
    }),
  });

  return backend;
};
